import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  public success(mensagem: string) {
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: mensagem,
      life: 2000,
    });
  }

  public error(mensagem: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: mensagem,
      life: 2000,
    });
  }

  public warn(mensagem: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Aviso',
      detail: mensagem,
      life: 2000,
    });
  }

  public info(mensagem: string) {
    this.messageService.add({
      severity: 'info',
      summary: 'Informação',
      detail: mensagem,
      life: 2000,
    });
  }
}
